import { useQuery } from '@tanstack/react-query';

import { TeliaSegment } from '@telialt/utils/src/segment';

import { COMPARISON_QUERY_KEYS } from '../constants/constants';
import { apiGetProductsCompareClassifications } from './api';

export const useLoadCompareClassifications = (segment: TeliaSegment, productCodes: string[]) => {
    return useQuery({
        queryKey: [COMPARISON_QUERY_KEYS.PRODUCTS_COMPARE_FEATURES, segment, productCodes],
        queryFn: () => apiGetProductsCompareClassifications(segment, productCodes),
        select: ({ data }) => data,
        enabled: productCodes?.length > 0,
    });
};
